import { FC } from "react";
import { Page } from "../../../Components/Page";
import { Button, Group, Loader, Table } from "@mantine/core";
import { Link } from "react-router-dom";
import { components } from "../../../openapi/generated-types";
import { DateTime } from "luxon";
import { useCompetitionList } from "../../../hooks/useCompetitionList.ts";
import { setupFWC2026 } from "../../../fwc-2026.ts";
import { setupGSC2026 } from "../../../gsc-2026.ts";
import { IconMan, IconWoman } from "@tabler/icons-react";

interface TableRowProps {
  competition: components["schemas"]["Competition"];
}

const TableRow: FC<TableRowProps> = (props) => {
  const { competition } = props;

  return (
    <Table.Tr>
      <Table.Td>
        <Link to={competition.id}>{competition.name}</Link>
      </Table.Td>
      <Table.Td>{competition.location}</Table.Td>
      <Table.Td>
        {DateTime.fromISO(competition.start).toFormat("dd.MM.yyyy")}
      </Table.Td>
      <Table.Td>
        {DateTime.fromISO(competition.end).toFormat("dd.MM.yyyy")}
      </Table.Td>
      <Table.Td>{competition.teamIds.length}</Table.Td>
    </Table.Tr>
  );
};

export const CompetitionOverview: FC = () => {
  const competitionData = useCompetitionList();

  if (!competitionData.isSuccess) {
    return <Loader />;
  }

  return (
    <Page
      title="Turniere"
      action={
        <Button component={Link} to="new">
          Neues Turnier
        </Button>
      }
    >
      <Group gap="xs" wrap="wrap" mb="md">
        <Button
          color="blue.9"
          onClick={() => void setupFWC2026()}
          leftSection={<IconMan />}
        >
          FWC 2026 generieren
        </Button>
        <Button
          color="red.9"
          onClick={() => void setupGSC2026()}
          leftSection={<IconWoman />}
        >
          GSC 2026 generieren
        </Button>
      </Group>
      <Table.ScrollContainer minWidth={500}>
        <Table>
          <Table.Thead>
            <Table.Tr>
              <Table.Th>Turnier</Table.Th>
              <Table.Th>Ort</Table.Th>
              <Table.Th>Start</Table.Th>
              <Table.Th>Ende</Table.Th>
              <Table.Th>Mannschaften</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {competitionData.data.competitions.map((c) => (
              <TableRow key={c.id} competition={c} />
            ))}
          </Table.Tbody>
        </Table>
      </Table.ScrollContainer>
    </Page>
  );
};
